import { MANAGE_IMAGES_MODAL as FEATURE_PREFIX } from 'featurePrefix.ids'

const STYLE_INFO_PREFIX = 'style-info'
const PRODUCT_IMAGES_PREFIX = 'product-images'
const STYLE_COLORS_PREFIX = 'style-colors'
const GALLERY_PREFIX = ''

export const ModalIds = {
  CloseButton: `${FEATURE_PREFIX}__close-button`,
  Modal: FEATURE_PREFIX,
  SaveButton: `${FEATURE_PREFIX}__save-button`,
  Title: `${FEATURE_PREFIX}__title`,
} as const

export const StyleInfoIds = {
  StyleId: `${FEATURE_PREFIX}__${STYLE_INFO_PREFIX}__style-id`,
  StyleName: `${FEATURE_PREFIX}__${STYLE_INFO_PREFIX}__style-name`,
  StyleFabrication: `${FEATURE_PREFIX}__${STYLE_INFO_PREFIX}__style-fabrication`,
  StyleSilhouette: `${FEATURE_PREFIX}__${STYLE_INFO_PREFIX}__style-silhouette`,
} as const

export const ProductImagesIds = {
  Card: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}`,
  AssignImagesAction: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}__assign-images-action`,
  AssignImagesButton: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}__assign-images-button`,
  Image: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}__image`,
  UploadImageButton: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}__upload-image-button`,
  RemoveButton: `${FEATURE_PREFIX}__${PRODUCT_IMAGES_PREFIX}__remove-button`,
} as const

export const StyleColorsIds = {
  Card: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}`,
  AssignImageButton: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__assign-image-button`,
  Container: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__container`,
  EditSwatches: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__edit-swatches`,
  Image: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__image`,
  RemoveButton: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__remove-button`,
  UploadImageButton: `${FEATURE_PREFIX}__${STYLE_COLORS_PREFIX}__upload-image-button`,
} as const

export const GalleryIds = {
  Container: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__container`,
  DeselectAllButton: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__deselect-all-button`,
  UploadButton: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__upload-button`,
  RemoveButton: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__remove-button`,
  Search: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__search`,
  PreviousButton: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__previous-button`,
  NextButton: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__next-button`,
  GalleryItem: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__gallery-item`,
  ImageContainer: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__image-container`,
  Image: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__image`,
  ImageName: `${FEATURE_PREFIX}__${GALLERY_PREFIX}__image-name`,
} as const
